export default __webpack_public_path__ + "static/media/Deathstroke.fa792ca7.png";